import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {alpha} from '@mui/material/styles';

export interface NodePreviewRow {
    label?: string;
    text: string;
    lines?: 2;
}

const NodePreview = ({rows}: {rows: NodePreviewRow[]}) => {
    const populated = rows.filter(row => row.text);
    if (!populated.length) return null;

    return (
        <Stack gap={0.5} sx={{mt: 1, minWidth: 0}}>
            {populated.map((row, index) => (
                <Typography key={index} component="div" variant="body2" sx={{
                    color: theme => alpha(theme.palette.text.primary, 0.75),
                    lineHeight: 1.4,
                    overflow: 'hidden',
                    overflowWrap: 'anywhere',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: row.lines ?? 1,
                }}>
                    {row.label && <span>{row.label}: </span>}
                    {row.text}
                </Typography>
            ))}
        </Stack>
    );
};

export default NodePreview;
